module.exports = ".navigation-bar-desktop-spacer {\n    height: 80pt;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navigation-bar-desktop-spacer/navigation-bar-desktop-spacer.component.css
// module id = ./src/app/components/navigation-bar-desktop-spacer/navigation-bar-desktop-spacer.component.css
// module chunks = main